module.exports = __webpack_public_path__ + "static/media/console.929b7f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/console.png
// module id = 2452
// module chunks = 0